import React from 'react';
import { motion } from 'framer-motion';
export function TarotCardImage() {
  return <section className="py-16 px-4 bg-[#0C0F17]" data-id="element-274">
      <div className="max-w-2xl mx-auto" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-276">
          <img src="https://cdn.magicpatterns.com/uploads/azRrGxxagq3D5RUfTgcRPc/The_Sun_Tarot_Card__Your_Bright_Path_to_Joy,_Clarity__Success.jpg" alt="The Sun Tarot Card" className="w-full max-w-md mx-auto rounded-2xl shadow-2xl border-2 border-[#CFA86A]/30" style={{
          boxShadow: '0 20px 60px rgba(207, 168, 106, 0.3)'
        }} data-id="element-277" />

          {/* Decorative glow effect */}
          <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
          background: 'radial-gradient(circle at center, rgba(207, 168, 106, 0.15), transparent 70%)'
        }} data-id="element-278" />
        </motion.div>
      </div>
    </section>;
}